
export const ROUTE_BUYER_RECAP_URL = `/recap`;
// export const ROUTE_BUYER_SUBRO_URL = `${ROUTE_BUYER_PREFIX}/subrogation`;
